import { useEffect, useState } from 'react';
import PageContainer from '../components/PageContainer';
import KpiCard from '../components/KpiCard';
import WeeklyKpiChart from '../components/WeeklyKpiChart';

export default function Kpis() {
  const [metrics, setMetrics] = useState({ total_tags: 0, serviced_tags: 0, coverage_percent: 0 });
  useEffect(() => {
    fetch('/api/kpi.php?action=cumulative')
      .then((r) => r.json())
      .then((d) => setMetrics(d))
      .catch(() => {});
  }, []);

  return (
    <PageContainer>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold mb-1">KPI's</h1>
        <p className="text-muted">Key performance indicators for tag audits</p>
      </header>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 h-full">
        <div className="flex flex-col space-y-4 lg:col-span-1">
          <KpiCard
            title="Total Tags"
            value={metrics.total_tags || 0}
            subtitle="All registered tags"
            tooltip="Total number of tags in the registry"
            link="#"
          />
          <KpiCard
            title="Serviced Tags"
            value={metrics.serviced_tags || 0}
            subtitle="Tags serviced at least once"
            tooltip="Tags that appear in instrument audits"
            link="#"
          />
          <KpiCard
            title="Coverage %"
            value={parseFloat(Number(metrics.coverage_percent || 0).toFixed(1))}
            subtitle="Share of tags serviced"
            tooltip="Serviced tags divided by total tags"
            link="#"
          />
        </div>
        <div className="lg:col-span-2 min-h-[400px]">
          <WeeklyKpiChart />
        </div>
      </div>
    </PageContainer>
  );
}